import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../firebase"; // Firebase
import { ref, set } from "firebase/database"; // Database
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Register = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    // Fungsi menyimpan data pengguna ke Firebase
    const saveUserToDatabase = (user) => {
        set(ref(db, `users/${user.uid}`), {
            email: user.email,
            saldo: 0, // Saldo awal 0
            uid: user.uid
        });
    };

    // Fungsi registrasi
    const handleRegister = async (e) => {
        e.preventDefault();
        try {
            const userCredential = await createUserWithEmailAndPassword(
                auth,
                email,
                password
            );
            const user = userCredential.user;

            // Simpan data pengguna
            saveUserToDatabase(user);

            toast.success("Registrasi berhasil!");
            setEmail("");
            setPassword("");
            navigate("/login"); // Redirect ke login
        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md m-10">
                <h2 className="text-3xl font-semibold text-center mb-6">
                    Register
                </h2>
                <form onSubmit={handleRegister} className="space-y-4">
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="input input-bordered w-full"
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="input input-bordered w-full"
                    />
                    {error && <p className="text-red-500">{error}</p>}
                    <button type="submit" className="btn btn-primary w-full">
                        Register
                    </button>
                </form>
                <div className="mt-4 text-center">
                    <span>Sudah punya akun? </span>
                    <Link to="/login" className="text-blue-500">
                        Login di sini
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Register;
